import Vue from 'vue';
import Router, { Route } from 'vue-router';
import Giveaway from '@/views/Giveaway.vue';
import Imprint from '@/views/Imprint.vue';
import Licenses from '@/views/Licenses.vue';
import logger from '@/services/logger';

function getLoggingData(to: Route, from: Route): {} | undefined {
  return {
    category: 'DgAvpPortal',
    to: {
      name: to.name,
      path: to.path,
      params: to.params
    },
    from: {
      name: from.name,
      path: from.path,
      params: from.params
    }
  };
}

Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: '/:id/imprint',
      name: 'imprint',
      component: Imprint
    },
    {
      path: '/:id/third-party-software',
      name: 'third-party-software',
      component: Licenses
    },
    {
      path: '/:id',
      name: 'giveaway',
      component: Giveaway
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.afterEach((to, from): void => {
  try {
    const subPath = to.path.split('/').pop() || '';
    if (['imprint', 'third-party-software'].includes(subPath)) {
      const id = from.params.id;

      if (id) {
        logger.info(
          `${to.name} displayed for Digital Giveaway with AUDI Code corresponding to ID: ${id}`,
          getLoggingData(to, from)
        );
      } else {
        logger.info(`${to.name} displayed for Digital Giveaway without AUDI Code`, getLoggingData(to, from));
      }
    }
  } catch (error) {
    logger.error(`Unexpected path`, getLoggingData(to, from), error);
  }
});

export default router;
